export var ENV;
(function (ENV) {
    ENV["development"] = "development";
    ENV["staging"] = "staging";
    ENV["production"] = "production";
})(ENV || (ENV = {}));
//# sourceMappingURL=types.js.map